import React from 'react'

const ClientExhibitorList = () => {
    return (
        <div>
            List
        </div>
    )
}

export default ClientExhibitorList
